"use client";

import { useEffect } from "react";

/**
 * Mounted once inside the Data & SAP BDC page. Watches every element
 * carrying the `datareveal` or `datastagger` class and adds `is-visible`
 * once it scrolls into view — datasap.css does the actual fade/slide-up
 * transition. Mirrors enterprise-transformation/EnterpriseTransformationReveal.tsx.
 */
export default function DataSapReveal() {
  useEffect(() => {
    const els = Array.from(
      document.querySelectorAll<HTMLElement>(".datareveal, .datastagger")
    );
    if (!els.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );

    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return null;
}
